import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'administered-channels'

type AdministeredChannels = string[]

export const administeredChannelsStorage =
  createKeyvalStorage<AdministeredChannels>(key)

export const administeredChannelsView =
  createKeyvalView<AdministeredChannels>(key)
